import { chatActions } from "./ChatActions";

const initState = {
    chatMessageList: [],
    showSpinner: false,
    chatMessagesCount: 0,
    totalPages: 0,
    prog:67,
    chatReceiver: null,
    messageContent: "",
    messageAttachment: null,
    showEmojis: false,
    error: null,
    messageAttachmentName: "",
    messageSending: false,
    chatMessagesPage: 1,
    scrollPointerForChat: ""
};

export default function chatPageReducer(state = initState, action) {
    switch (action.type) {
        case chatActions.toggleSpinner:
            return toggleSpinner(state, action);
        case chatActions.setError:
            return setError(state, action);
        case chatActions.setChatMessageList:
            return setChatMessageList(state, action);
        case chatActions.setChatMessagesCount:
            return setChatMessagesCount(state, action);
        case chatActions.setTotalPages:
            return setTotalPages(state, action);
        case chatActions.setChatReceiver:
            return setChatReceiver(state, action);
        case chatActions.setMessageContent:
            return setMessageContent(state, action);
        case chatActions.setMessageAttachment:
            return setMessageAttachment(state, action);
        case chatActions.toggleShowEmojis:
            return toggleShowEmojis(state, action);
        case chatActions.setProg:
            return setProg(state, action);
        case chatActions.hideEmojis:
            return hideEmojis(state);
        case chatActions.clearMessageContent:
            return clearMessageContent(state);
        case chatActions.removeMessageAttachment:
            return removeMessageAttachment(state);
        case chatActions.setMessageAttachmentName:
            return setMessageAttachmentName(state, action);
        case chatActions.setMessageSending:
            return setMessageSending(state, action);
        case chatActions.increasePageNumber:
            return increasePageNumber(state, action);
        case chatActions.changeScrollPointerForChat:
            return changeScrollPointerForChat(state, action);
        default:
            return state;
    }
}

function changeScrollPointerForChat(state, action) {
    return {
        ...state,
        scrollPointerForChat: action.payload
    };
}

function increasePageNumber(state, action) {
    return {
        ...state,
        chatMessagesPage: state.chatMessagesPage + 1
    };
}

function setMessageSending(state, { payload }) {
    return {
        ...state,
        messageSending: payload
    };
}

function setMessageAttachmentName(state, { payload }) {
    return {
        ...state,
        messageAttachmentName: payload
    };
}

function removeMessageAttachment(state) {
    return {
        ...state,
        messageAttachment: null
    };
}

function clearMessageContent(state) {
    return {
        ...state,
        messageContent: ""
    };
}

function toggleShowEmojis(state, { payload }) {
    return {
        ...state,
        showEmojis: payload
    };
}

function setProg(state, { payload }) {
    return {
        ...state,
        prog: payload
    };
}

function setMessageContent(state, { payload }) {
    return {
        ...state,
        messageContent: payload
    };
}

function setChatReceiver(state, { payload }) {
    return {
        ...state,
        chatReceiver: payload
    };
}

function toggleSpinner(state, { payload }) {
    return {
        ...state,
        showSpinner: payload
    };
}

function setChatMessageList(state, { payload }) {
    return {
        ...state,
        chatMessageList: payload
    };
}

function setChatMessagesCount(state, { payload }) {
    return {
        ...state,
        chatMessagesCount: payload
    };
}

function setTotalPages(state, { payload }) {
    return {
        ...state,
        totalPages: payload
    };
}

function setMessageAttachment(state, { payload }) {
    return {
        ...state,
        messageAttachment: payload
    };
}

function hideEmojis(state) {
    return {
        ...state,
        showEmojis: false
    };
}

function setError(state, { payload }) {
    return {
        ...state,
        error: payload
    };
}
